import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader, Loading, ErrorBox, Empty, PhaseBadge, useSort } from "@/components/common";
import { api, errMsg } from "@/lib/api";
import { useI18n, PHASES, ROLES } from "@/lib/i18n";

export default function Audits() {
  const { tx, lbl } = useI18n();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  const [q, setQ] = useState("");
  const [phase, setPhase] = useState("");
  useEffect(() => {
    const t = setTimeout(() => api.get("/audits", { params: { q: q || undefined, phase: phase || undefined } }).then((r) => setRows(r.data)).catch((e) => setErr(errMsg(e))), 250);
    return () => clearTimeout(t);
  }, [q, phase]);
  const { sorted, SortTh } = useSort(rows, "title");
  return (
    <div>
      <PageHeader eyebrow={tx("Missions", "Missions")} title={tx("Audits", "Audits")} subtitle={tx("Créez un audit depuis la fiche client.", "Create an audit from the client file.")} />
      <div className="flex flex-wrap gap-3 mb-4">
        <div className="relative"><Search className="h-4 w-4 absolute left-2.5 top-2.5 text-slate-400" /><Input data-testid="audits-search-input" className="pl-8 w-72" placeholder={tx("Rechercher…", "Search…")} value={q} onChange={(e) => setQ(e.target.value)} /></div>
        <select data-testid="audits-phase-filter" className="nselect" value={phase} onChange={(e) => setPhase(e.target.value)}>
          <option value="">{tx("Toutes phases", "All phases")}</option>
          {Object.keys(PHASES).map((p) => <option key={p} value={p}>{lbl(PHASES, p)}</option>)}
        </select>
      </div>
      {err && <ErrorBox error={err} />}
      {!rows ? <Loading /> : rows.length === 0 ? <div className="card-surface"><Empty text={tx("Aucun audit autorisé", "No authorised audits")} /></div> : (
        <div className="card-surface overflow-x-auto">
          <table className="tbl" data-testid="audits-table">
            <thead><tr><SortTh k="title">{tx("Intitulé", "Title")}</SortTh><SortTh k="organization_name">Client</SortTh><SortTh k="period">{tx("Période", "Period")}</SortTh><SortTh k="phase">Phase</SortTh><th>{tx("Mon rôle", "My role")}</th></tr></thead>
            <tbody>{sorted.map((a) => (
              <tr key={a.id} data-testid={`audit-row-${a.id}`}>
                <td><Link className="font-medium text-[#2176AE] hover:underline" to={`/audits/${a.id}`}>{a.title}</Link></td>
                <td>{a.organization_name}</td><td>{a.period}</td><td><PhaseBadge phase={a.phase} /></td><td className="text-xs">{lbl(ROLES, a.my_role)}</td>
              </tr>))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
